export default __webpack_public_path__ + "static/media/i-360video - bcr.19ab7e6c.svg";